import { spacing } from './spacing';

export const sizes = {
  ...spacing,
};
